'use client';

import { useId } from 'react';
import { useIntl } from 'react-intl';

import { FontSizes, FontWeights } from '@calm-web/design-system';

import messages from '@/components/SimplifiedSignup/configs/Control/messages';

import ValuePropsList, { type ValuePropsListProps } from '../ValuePropsList';
import styles from './styles.module.css';

export type BasicValuePropsListProps = Omit<
	ValuePropsListProps,
	'className' | 'data-testid' | 'gapSize' | 'title' | 'valuePropsIconColor'
>;

export default function BasicValuePropsList(valuePropsListProps: BasicValuePropsListProps) {
	const id = useId();
	const { formatMessage } = useIntl();
	return (
		<ValuePropsList
			{...valuePropsListProps}
			className={styles.basicValuePropsList}
			data-testid="sisu-basic-value-props-list"
			gapSize="0px"
			id={id}
			title={formatMessage(messages.includedBasic)}
			titleProps={{
				size: FontSizes.lg,
				weight: FontWeights.Regular,
			}}
			valuePropIconProps={{
				$color: 'gray4',
			}}
		/>
	);
}
